import { render, staticRenderFns } from "./CardTraffic.vue?vue&type=template&id=47523df2&"
import script from "./CardTraffic.vue?vue&type=script&lang=js&"
export * from "./CardTraffic.vue?vue&type=script&lang=js&"
import style0 from "./CardTraffic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports